import Button from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';

import { EmptyState } from '@/components/atoms/EmptyState';
import { useTranslator } from '@/hooks/useTranslator';

export const NoCustomersView: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return (
    <EmptyState.Container>
      <EmptyState.Title>{tr('NO_CUSTOMERS_YET_TITLE')}</EmptyState.Title>
      <EmptyState.Actions>
        <Button component={Link} to="new" variant="contained" size="compact">
          {tr('ADD_NEW_CUSTOMER')}
        </Button>
      </EmptyState.Actions>
    </EmptyState.Container>
  );
};
